import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "sizeCtrl",
  "use": "sizeCtrl-usage",
  "viewBox": "0 0 20 17.09",
  "content": "<symbol viewBox=\"0 0 20 17.09\" id=\"sizeCtrl\"><title>sizeCtrl</title><path d=\"M19,13.64H7.38a1.09,1.09,0,0,1,0-2.18H19a1.09,1.09,0,0,1,0,2.18Z\" transform=\"translate(0 -1.45)\" /><path d=\"M19,8.55H7.38a1.09,1.09,0,0,1,0-2.18H19a1.09,1.09,0,0,1,0,2.18Z\" transform=\"translate(0 -1.45)\" /><path d=\"M18.91,3.64H1.09a1.09,1.09,0,0,1,0-2.18H18.91a1.09,1.09,0,0,1,0,2.18Z\" transform=\"translate(0 -1.45)\" /><polygon points=\"5.09 12.18 0 8.54 5.09 4.91 5.09 12.18\" /><path d=\"M1.09,16.36H18.91a1.09,1.09,0,0,1,0,2.18H1.09a1.09,1.09,0,0,1,0-2.18Z\" transform=\"translate(0 -1.45)\" /><path d=\"M1.09,16.36\" transform=\"translate(0 -1.45)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/sizeCtrl.svg
// module id = ribp
// module chunks = 264